<template>
  <cdr-icon>
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect
        x="2.5"
        y="4.5"
        width="19"
        height="15"
        rx="2"
      />
      <circle
        cx="8.5"
        cy="11"
        r="2.2"
      />
      <path d="M5 16.2c.7-1.5 2-2.3 3.5-2.3s2.8.8 3.5 2.3" />
      <path d="M15 9.5h4M15 13.5h4" />
    </g>
  </cdr-icon>
</template>

<script setup lang="ts">
import { CdrIcon } from '@rei/cedar';
</script>
